import React from "react"
import { Row, Col, ListGroupItem } from "reactstrap"
import MenuFeaturesListNameToggle from "./menuFeaturesListNameToggle"
import MenuFeaturesListActionsToggle from "./menuFeaturesListActionsToggle"
const { useSortable } = require("@dnd-kit/sortable")
const { CSS } = require("@dnd-kit/utilities")

const MenuFeatureListItem = ({
  item,
  setFeatureIsLoaded,
  setSelectedFeature,
  selectedFeature,
  openSelectIconModal,
  selectedEvent,
  isEventFeature,
  setEditParams
}) => {
  const {
    transform,
    transition,
    setNodeRef,
    isDragging,
    attributes,
    listeners,
  } = useSortable({
    id: item?.id,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition,
    opacity: isDragging ? 0.6 : 1,
    zIndex: isDragging ? 1 : 0,
  }
  return (
    <div ref={setNodeRef} key={item?.id} style={style}>
      <ListGroupItem
        onClick={() => {
          if (!selectedFeature || selectedFeature?.id !== item?.id) {
            setFeatureIsLoaded(false)
            setSelectedFeature(item)
          }
        }}
        style={{
          borderRadius: "5px",
          border: "1px solid #ced4da",
          backgroundColor: selectedFeature?.id === item?.id ? "#E8E8E8" : "",
        }}
        className="my-1"
      >
        <Row className="align-items-center">
          <Col xs={2} md={1} className="ps-0" {...attributes} {...listeners}>
            <i className="bx bx-sm bx-menu"></i>
          </Col>
          <Col xs={2}>
            <img
              src={item?.icon?.url || ""}
              style={{
                width: "30px",
                height: "auto",
                paddingLeft: "5px",
              }}
            />
            <p
              style={{
                marginTop: "5px",
                cursor: "pointer",
                color: "#cc2288",
                minWidth: "fit-content",
              }}
              onClick={openSelectIconModal}
            >
              <u>Select</u>
            </p>
          </Col>
          <Col>
            <MenuFeaturesListNameToggle feature={item} isEventFeature={isEventFeature} />
          </Col>
          <Col xs={3} md={2} xl={3}>
            <MenuFeaturesListActionsToggle
              feature={item}
              eventId={selectedEvent?.id}
              isEventFeature={isEventFeature}
              eventStatus={selectedEvent?.published}
              setEditParams={setEditParams}
            />
          </Col>
        </Row>
      </ListGroupItem>
    </div>
  )
}

export default MenuFeatureListItem
